import _ from 'lodash';
import config from './default';

const qa = _.cloneDeep(config);

qa.api = {
  ez_pay: {
    hostInstances: 'https://api.qa.ez-pay.co/ez-pay/v1',
  },
  rcp: {
    hostInstances: 'https://api.qa.kubra.io/rcp/v1',
  }
};

qa.awsWafUrl = "https://4d640c2bc052.edge.sdk.awswaf.com/4d640c2bc052/860a27ea53cc/challenge.js";

export default qa;
